<template>
  <div v-if="isInit && !isLogin" v-show="webShow" class="login-pop">
    <div class="box">
      <a
        href="javascript:;"
        class="close"
        @click="$store.commit('app/setLoginPop', false)"
      ></a>
      <div class="title">
        请用<span>迅雷账号</span>登录，<span>会员奖励</span>将自动充值
      </div>
      <div style="width:264px;height:300px;background:#fff">
        <Login dom-id="xl_login_pop" type="popup" @show="webShow = true" />
      </div>
    </div>
  </div>
</template>

<script>
import Login from './Login'
import getRealUserSession from '~/utils/getRealUserSession'
export default {
  components: {
    Login
  },
  data() {
    return {
      webShow: false,
      isInit: false,
      isLogin: false
    }
  },
  async mounted() {
    const { userid, sessionid } = await getRealUserSession({})
    this.isInit = true
    if ((userid && sessionid) || this.$store.getters.isLogin) {
      this.isLogin = true
    }
  }
}
</script>
